// @flow

import * as React from 'react';

import { ContactForm, CONTACTS_FORM } from '@gandi/domain-configuration';
import { Base } from '@gandi/ui';

import type { FormComponentProps } from 'gandi.react-form';

import type { Step } from '../types';

import styles from './DrawerForm.scss';

type Props = {
  step: Step,
  isWorking: boolean,
  form: FormComponentProps,
  formButtons: Array<React.MixedElement>,
  stopSubmit: (string, string | void) => mixed,
  currentStepErrors: { [key: string]: string } | {},
};

export default class DrawerForm extends React.Component<Props> {
  componentDidMount() {
    // $FlowFixMe[incompatible-call] currentStepErrors or stopSumit is not well typed
    this.props.stopSubmit(CONTACTS_FORM, this.props.currentStepErrors);
    this.props.form.touch(...Object.keys(this.props.currentStepErrors));
  }

  render(): React.Node {
    // FIXME: implement list cell with secondary button
    return (
      <Base padding="small" backgroundColor="surface" separatorTop key="drawer">
        <div className={styles.centered}>
          <ContactForm
            // $FlowFixMe[incompatible-type]
            fqdn={this.props.step.domainInfo.fqdn}
            tld={this.props.step.domainInfo.tld}
            role={this.props.step.role}
            phase={this.props.step.domainInfo.phase}
            // $FlowFixMe[incompatible-type]
            process={this.props.step.domainInfo.process}
            initialValues={this.props.form.initialValues}
            handleSubmit={this.props.form.handleSubmit}
            isWorking={this.props.isWorking}
            formProps={this.props.form}
          />
          {this.props.formButtons}
        </div>
      </Base>
    );
  }
}
